import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReferenceDataLabels } from 'rome-library';
import { RedirectFromOldAppService } from '../../services/redirect-from-old-app.service';

@Component({
  selector: 'boi-redirect-from-old-app',
  templateUrl: './redirect-from-old-app.page.html'
})
export class RedirectFromOldAppPage implements OnInit {
  public referenceDataLabels = ReferenceDataLabels;

  constructor(private readonly route: ActivatedRoute, private readonly redirectService: RedirectFromOldAppService) {}

  public ngOnInit(): void {
    const oldUrlFragment = this.route.snapshot.fragment;

    const distFolderName = window.location.pathname.split('/')[1];
    const propositionCode = oldUrlFragment.split('/')[2];
    const newUrlEnding = this.redirectService.mapOldUrlToNew(oldUrlFragment);

    const newUrl = `/${distFolderName}/${propositionCode}/${newUrlEnding}`;

    window.location.replace(newUrl);
  }
}
